import { render, staticRenderFns } from "./ItemRecords.vue?vue&type=template&id=0fb50b7b"
import script from "./ItemRecords.vue?vue&type=script&lang=js"
export * from "./ItemRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports